import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=10248673&"
import script from "./bar.ts?vue&type=script&lang=js&"
export * from "./bar.ts?vue&type=script&lang=js&"
import style0 from "./bar.vue?vue&type=style&index=0&id=10248673&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports